import "./AboutUs.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import TheAnalyticalEdge from "./sections/TheAnalyticalEdge";
import VerifiedQualityStandards from "./sections/VerifiedQualityStandards";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <FraternalExcellenceHeader />
      <TheAnalyticalEdge />
      <VerifiedQualityStandards />
      <Footer />
    </div>;
}